import orderBy from 'lodash/orderBy';

export const groupThreadsByUpdateDate = (items) => {
  const oneDay = 24 * 60 * 60 * 1000; // in milliseconds
  const now = new Date();
  const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const today = startOfDay(now);
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const groups: { [key: string]: any[] } = {};
  const sortedThreads = orderBy(items, 'createdAt', 'desc');
  sortedThreads.forEach((item) => {
    const updateDate = new Date(item.createdAt);
    // @ts-ignore
    const diffTime = Math.abs(today - startOfDay(updateDate));
    const diffDays = Math.floor(diffTime / oneDay);

    let group;

    if (diffDays === 0) {
      group = 'Today';
    } else if (diffDays === 1) {
      group = 'Yesterday';
    } else if (diffDays > 1 && diffDays <= 7) {
      group = 'This Week';
    } else if (diffDays > 7 && diffDays <= 14) {
      group = 'Last Week';
    } else {
      const weeksAgo = Math.floor(diffDays / 7);
      group = `${weeksAgo} Weeks Before`;
    }

    if (!groups[group]) {
      groups[group] = [];
    }

    groups[group].push(item);
  });

  Object.keys(groups).forEach((key) => {
    if (groups[key].length === 0) {
      delete groups[key];
    }
  });

  return groups;
};
